<template>
  <div class="index-container">
    <custom-video />
    <div class="company-profile">
      <!-- 左侧内容区 -->
      <div class="profile-content">
        <div class="profile-title">
          <span>会社概要</span>
          <!--          <img :src="imgUrl + 'tiktok-white.png'" alt="TikTok图标" class="tiktok-icon" />-->
        </div>
        <p class="profile-desc">
          日本のTikTok電通連筐代行分野で業界の<br />
          リーディングカンパニーとなり、<br />
          フォロワーがコンテンツと流量の効率的な転換<br />
          を実現できるよう導く
        </p>
        <button class="inquiry-btn" style="padding: 10px 20px;font-size: 16px;" @click="toRelation">
          お問い合わせ →
        </button>
      </div>

      <!-- 右侧图片区 -->
      <img :src="imgUrl + 'build-gray.png'" alt="会社ビル" class="building-img" />
    </div>
    <service-swiper />
    <div class="push-box">
      <div class="title-box flex row-between col-center">
        <div>最新のプッシュ</div>
        <div class="desc flex row-between col-center" @click="toNews">
          もっと見る<img :src="imgUrl + 'arrow-right.png'" />
        </div>
      </div>
      <div class="push-list">
        <div
          class="push-item"
          v-for="(item, index) in pushList"
          :key="item.id"
          @click="toNewsDetail(item, index)"
        >
          <div class="push-title">
            {{ item.updateTime.split(' ')[0] }}
          </div>
          <div class="push-desc text-ellipsis">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <!--   关于我们 -->
    <div class="about-box">
      <div class="title">私たちはここであなたの到着をお待ちしております</div>
      <img class="map" :src="imgUrl + 'maps.png'" />
      <relation />
    </div>
    <!--  合作伙伴  -->
    <div class="partner-box">
      <div>パートナー</div>
      <div class="partner-list">
        <img v-for="item in 9" :key="item" :src="imgUrl + 'logo-0' + item + '.png'" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceSwiper from '@/components/Moudle/Index/ServiceSwiper.vue'
import CustomVideo from '@/components/Moudle/Index/CustomVideo.vue'
import Relation from '@/components/Moudle/Index/Relation.vue'
import { getDynamic } from '@/api/index'

export default {
  name: 'index',
  components: { Relation, CustomVideo, ServiceSwiper },
  data() {
    return {
      imgUrl: process.env.VUE_APP_FILE_URL,
      pushList: []
    }
  },
  mounted() {
    this.getDynamic()
  },
  methods: {
    getDynamic() {
      getDynamic({ pageNo: 1, pageSize: 4 }).then(res => {
        this.pushList = res.data.list
      })
    },
    toNews() {
      this.$router.push('/latestUpdates')
    },
    toNewsDetail(item, index) {
      // const params = {
      //   index: index,
      //   pageNo: 1,
      //   pageSize: 10
      // }
      this.$router.push(`/push-details/${item.id}`)
    },
    toRelation() {
      this.$router.push('/relation')
    }
  }
}
</script>

<style scoped lang="scss">
// 混合器：响应式适配
@mixin responsive {
  @media (max-width: $mobile-breakpoint) {
    @content;
  }
}

.index-container {
  background: $bg-color;
  .company-profile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 150px 200px;
    background: $bg-color;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    //@media (min-width: $mobile-breakpoint) {
    //  height: 100vh;
    //}

    // 响应式布局
    @include responsive {
      flex-direction: column;
    }

    .profile-content {
      flex: 1;

      @include responsive {
        margin-right: 0;
        margin-bottom: 20px;
      }

      .profile-title {
        display: flex;
        align-items: center;
        font-size: 40px;
        font-weight: 500;
        margin-bottom: 15px;
        @media (max-width: $mobile-breakpoint) {
          font-size: 34px;
        }

        .tiktok-icon {
          width: 1.5rem;
          height: 1.5rem;
          margin-left: 10px;
        }
      }

      .profile-desc {
        font-size: 16px;
        line-height: 1.8;
        color: $text-color;
        margin-bottom: 20px;
        @media (max-width: 768px) {
          font-size: 14px;
          margin-top: 10px;
        }
      }

      .inquiry-btn {
        background: #0098fd;
        color: #fff;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: #1169cc;
        }
      }
    }

    .building-img {
      height: auto;
      width: 50%;
      box-shadow: 20px 20px 20px 0 rgba(137, 191, 255, 0.25);
      @media (max-width: $mobile-breakpoint) {
        width: 80%;
      }
    }
  }
  .push-box {
    padding: 64px 80px;
    .title-box {
      color: #303030;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px; /* 105% */
      letter-spacing: 0.32px;
      margin-bottom: 24px;
      @media (max-width: $mobile-breakpoint) {
        font-size: 18px;
        margin-bottom: 24px;
      }
      .desc {
        color: #737373;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 42px; /* 175% */
        letter-spacing: 0.32px;
        cursor: pointer;
        @media (max-width: $mobile-breakpoint) {
          font-size: 12px;
        }
        img {
          width: 1.5rem;
          @media (max-width: $mobile-breakpoint) {
            width: 1rem;
          }
        }
      }
    }
    .push-list {
      color: #454545;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.196px;
      @media (max-width: $mobile-breakpoint) {
        font-size: 12px;
      }
      .push-item {
        display: flex;
        gap: 32px;
        padding: 36px 0 32px;
        border-bottom: 1px solid #e2e2e2;
        cursor: pointer;
        .push-title {
          flex-shrink: 0;
        }
      }
    }
  }
  .about-box {
    padding: 64px 34px;
    .title {
      color: #303030;
      font-size: 40px;
      line-height: 60px;
      letter-spacing: 5px;
      margin-bottom: 42px;
      margin-left: 46px;
      @media (max-width: $mobile-breakpoint) {
        font-size: 18px;
        line-height: 24px;
      }
    }
    .map {
      width: 100%;
    }
  }
  .partner-box {
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 0 34px 67px;
    @media (max-width: $mobile-breakpoint) {
      font-size: 20px;
    }
    .partner-list {
      margin-top: 63px;
      display: flex;
      flex-wrap: wrap;
      gap: 39px 48px;
      img {
        height: 100px;
        border-radius: 20px;
      }
    }
  }
}
</style>
